<template>
    <iframe
        width="100%"
        height="100%"
        :src="dashboardUrl"
        id="quicksight-display">
    </iframe>
</template>


<script>
export default {
  props: ['dashboardUrl'],
  data() {
    return {}
  },

  methods: {
  },

  mounted() {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/quicksight/dashboard.vue